import type { ReactNode } from 'react';

import { cn, cva, type VariantProps } from '../../shared';
import { HEADER_HEIGHT } from '../app-shell/header-size';

export const headerVariants = cva(
  'bg-card text-card-foreground px-page-x gap-inline flex w-full items-center justify-between',
  {
    variants: {
      size: HEADER_HEIGHT,
      sticky: { true: 'sticky top-0 z-sticky', false: '' },
      border: { true: 'border-border border-b', false: '' },
      // invisible, not unmounted, so a fixed header's spacer never goes stale.
      hidden: { true: 'invisible', false: '' },
    },
    defaultVariants: { size: 'md', sticky: false, border: true, hidden: false },
  },
);

type HeaderVariants = VariantProps<typeof headerVariants>;

export interface HeaderProps {
  size?: NonNullable<HeaderVariants['size']>;
  sticky?: boolean;
  border?: boolean;
  hidden?: boolean;
  logo?: ReactNode;
  leading?: ReactNode;
  nav?: ReactNode;
  actions?: ReactNode;
  mobileMenuTrigger?: ReactNode;
  className?: string;
}

export function Header({
  size,
  sticky,
  border,
  hidden,
  logo,
  leading,
  nav,
  actions,
  mobileMenuTrigger,
  className,
}: HeaderProps) {
  return (
    <header
      aria-hidden={hidden ? true : undefined}
      className={cn(headerVariants({ size, sticky, border, hidden }), className)}
    >
      <div className="gap-inline flex min-w-0 items-center">
        {mobileMenuTrigger}
        {logo}
        {leading}
      </div>
      {nav ? <nav className="min-w-0 flex-1">{nav}</nav> : null}
      {actions ? <div className="gap-inline flex shrink-0 items-center">{actions}</div> : null}
    </header>
  );
}
